/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let deleteMsgApiURL = root.deleteMsgApiUrl.link;
let allLeftChatListDetailsURL = root.allLeftChatListDetailsUrl.link;
let chatRoomPinnedApiURL = root.chatRoomPinnedApiUrl.link;
let chatRoomPinnedListApiURL = root.chatRoomPinnedListApiUrl.link;
let forwardMsgUserApiLink = root.forwardMsgUserApiLink.link;
let forwardMultiMsgUserApiLink = root.forwardMultiMsgUserApiLink.link;
let chatWithUserSearchApiUrl = root.chatWithUserSearchApiUrl.link;
let getUserNameListFromGroupApiUrl = root.getUserNameListFromGroupApiUrl.link;
let messageSearchApiUrl = root.messageSearchApiUrl.link;
let groupDeleteApiUrl = root.groupDeleteApiUrl.link;
let getAllUserChatListMBLUrl = root.getAllUserChatListMBLUrl.link;
let workspaceUserSearchApiURL =  root.workspaceUserSearchApiUrl.link;

export default {
  state: {
    getAllLeftChatListDetailsState:{},
    getChatRoomPinnedListState:{},
    getUserNameListFromGroupState:{},
    getAllUserChatListMBLState:{}
  },
  mutations: {
    getAllLeftChatListDetailsMutation(state, value) {
      Vue.set(state, 'getAllLeftChatListDetailsState', value);
    },
    getChatRoomPinnedListMutation(state, value) {
      Vue.set(state, 'getChatRoomPinnedListState', value);
    },
    getUserNameListFromGroupMutation(state, value) {
      Vue.set(state, 'getUserNameListFromGroupState', value);
    },
    getAllUserChatListMBLMuatation(state, value) {
     Vue.set(state, 'getAllUserChatListMBLState', value);
    },
  },
  actions: {
    // get User for chat Action
    getUserForChatAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(workspaceUserSearchApiURL  + '?q=' + payload.search_term).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // get Message Search Action
    getMessageSearchAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(messageSearchApiUrl  + '?q=' + payload.search_term + '&id=' + payload.id).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // get All Left Chat List Details
    getAllUserChatListMBLAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getAllUserChatListMBLUrl  + '?screen_height=' + window.outerHeight, payload).then(res => {
                context.commit('getAllUserChatListMBLMuatation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Group Delete Api Method Code Here
    deleteGroupInfoAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(groupDeleteApiUrl + payload.id + '/').then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get User Name List From Group Function
    getUserNameListFromGroupAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(getUserNameListFromGroupApiUrl + payload.id + '/').then(res => {
                context.commit('getUserNameListFromGroupMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Chat Room Pined List Function
    getChatRoomPinnedListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(chatRoomPinnedListApiURL, payload).then(res => {
                context.commit('getChatRoomPinnedListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Chat Room Pinned Function
    selectedChatRoomPinnedFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(chatRoomPinnedApiURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // get All Left Chat List Details
    getAllLeftChatListDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(allLeftChatListDetailsURL  + '?screen_height=' + window.outerHeight, payload).then(res => {
                context.commit('getAllLeftChatListDetailsMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Message Delete For Chat In Workspace
    deleteMsgOfChatInWorkspaceAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(deleteMsgApiURL + payload.data.id + '/?delete_for_everyone=' + payload.data.query).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Forward Message Api Function
    forwardMultiMessageToUsersFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(forwardMultiMsgUserApiLink, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Forward Message Api Function
    forwardMessageToUsersFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(forwardMsgUserApiLink, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // User Search Chat In Workspace
    seachUserOfChatInWorkspaceAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(chatWithUserSearchApiUrl + '?search_term=' + payload.query).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getAllLeftChatListDetailsGetters : state => state.getAllLeftChatListDetailsState,
    getChatRoomPinnedListGetters : state => state.getChatRoomPinnedListState,
    getUserNameListFromGroupGetters : state => state.getUserNameListFromGroupState,
    getAllUserChatListMBLGetters : state => state.getAllUserChatListMBLState
  }
}